export const REGISTER_RECRUITER_REQUEST = 'REGISTER_RECRUITER_REQUEST'
export const REGISTER_RECRUITER_SUCCESS = 'REGISTER_RECRUITER_SUCCESS'
export const REGISTER_RECRUITER_FAILED = 'REGISTER_RECRUITER_FAILED'
